import Parse from 'parse';
import router from '../../router/router';
import { singleEntityLoading } from '../mixins/loading-states';
/**
 * @class UserStore
 */
const UserModule = {
  namespaced: true,
  state: {
    ...singleEntityLoading.state,
    currentUser: null,
    currentUserPromise: null,
    language: null,
    isAdmin: false,
  },
  mutations: {
    ...singleEntityLoading.mutations,
    setCurrentUser(state, user) {
      state.currentUser = user;
    },
    setLanguage(state, language) {
      state.language = language;
    },
    setIsAdmin(state, isAdmin) {
      state.isAdmin = isAdmin;
    },
  },
  actions: {
    ...singleEntityLoading.actions,
    loadCurrentUser({ dispatch, commit }) {
      commit('setLoading');
      if (Parse.User.current()) {
        return Parse.User.current()
          .fetch()
          .then(() => {
            commit('setLoaded');
            commit('setCurrentUser', Parse.User.current());
            commit('setLanguage', Parse.User.current().get('language'));
            dispatch('checkIfUserIsAdmin');
          })
          .catch((error) => {
            if (error.code === 209) {
              dispatch('logout');
              router.replace('/');
            }
          });
      } else {
        commit('setLoaded');
        commit('setCurrentUser', null);
        commit('setLanguage', 'en');
        return Promise.resolve();
      }
    },
    login({ dispatch, commit, state }, user) {
      return Parse.User.logIn(user.email, user.password, null).then((user) => {
        commit('setCurrentUser', user);
        commit('setLanguage', user.get('language'));
      });
    },
    logout({ commit }) {
      return Parse.User.logOut().then(() => {
        commit('setCurrentUser', null);
      });
    },
    checkIfUserIsAdmin({ commit, state }) {
      let adminRoleQuery = new Parse.Query(Parse.Role);
      adminRoleQuery.equalTo('name', 'Admin');
      adminRoleQuery.equalTo('users', Parse.User.current());
      return adminRoleQuery.first().then((result) => {
        commit('setIsAdmin', !!result);
      });
    },
  },
  getters: {
    ...singleEntityLoading.getters,
    currentUser: (state) => state.currentUser || {},
    fullName: (state) => state.currentUser.get('firstname') + ' ' + state.currentUser.get('lastname'),
    language: (state) => state.language,
    isAdmin: (state) => state.isAdmin,
  },
};

export default UserModule;
